
<p-inc-mail-menu-content
    @search = "onSearch"
>
    <template v-slot:content>
        <v-list>
            <v-list-item
                v-for="(item, index) in templates"
                @click="onSelect(item)"
                :key="index"
                class="template-item"
            >
                <v-list-item-title
                    @click="onSelect"
                >
                    {{ item.name }}
                </v-list-item-title>
            </v-list-item>
        </v-list>
    </template>
</p-inc-mail-menu-content>
